<template>
	<div class="logo">
		<Transition name="logo-fade" mode="out-in">
			<img :key="logoSrc" :src="logoSrc" alt="justmum logo" aria-label="justmum logo" class="logo-image" />
		</Transition>
	</div>
</template>

<script lang="ts" setup>
import { computed } from "vue"
import { useThemeStore } from "@/stores/theme"

interface Props {
	type?: "default" | "small" | "large"
	dark?: boolean
	maxHeight?: string
}

const props = withDefaults(defineProps<Props>(), {
	type: "default",
	dark: undefined,
	maxHeight: "32px"
})

const themeStore = useThemeStore()

const isDark = computed<boolean>(() => props.dark ?? themeStore.isThemeDark)

const logoSrc = computed<string>(() => {
	const theme = isDark.value ? "dark" : "light"
	return new URL(`../../assets/images/justmum_logo_${props.type}_${theme}.svg`, import.meta.url).href
})
</script>

<style lang="scss" scoped>
.logo {
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;

	.logo-image {
		max-height: v-bind(maxHeight);
		height: 100%;
		width: auto;
		display: block;
		object-fit: contain;
	}
}

// Smooth transition between theme changes
.logo-fade-enter-active,
.logo-fade-leave-active {
	transition: opacity 0.2s ease-in-out;
}

.logo-fade-enter-from,
.logo-fade-leave-to {
	opacity: 0;
}
</style>
